import React, { useState } from 'react';
import PageLayout from '../components/PageLayout';
import Lightbox from '../components/Lightbox';
import './Immigration.css';

const Education = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState({ src: '', alt: '' });

  const openLightbox = (src, alt) => {
    setLightboxImage({ src, alt });
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage({ src: '', alt: '' });
  };

  return (
    <PageLayout 
      title="Techucation - AI & Blockchain Enhanced Learning" 
      subtitle="Overcoming cognitive limitations through AI/ML and Blockchain supported education technology, making learning more efficient and accessible for students worldwide."
    >
      <section className="immigration-section">
        <div className="container">
          <div className="immigration-intro">
            <h2>Future of Learning</h2>
            <p>
              Rayad Group pioneers efforts in making learning AI/ML and Blockchain supported Techucation for students, focusing on overcoming cognitive limitations of the brain and enhancing educational experiences.
            </p>
          </div>
          
          <div className="tab-content">
            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Cognitive Enhancement Technologies</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    We focus on overcoming cognitive limitations of the brain, such as avoiding short-term memory fog and language-learning difficulties through innovative technology solutions.
                  </p>
                  
                  <div className="info-section">
                    <h4>Brain Enhancement Solutions</h4>
                    <ul>
                      <li>Brain implants for cognitive augmentation</li>
                      <li>Instant language translation technologies</li>
                      <li>Memory enhancement and retention systems</li>
                      <li>Cognitive load reduction platforms</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Smart Learning Support</h4>
                    <ul>
                      <li>Smartphone solutions for cognitive challenges</li>
                      <li>Real-time learning assistance applications</li>
                      <li>Adaptive cognitive support systems</li>
                      <li>Brain-computer interface technologies</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=2122&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="Cognitive Enhancement Technologies" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=2122&auto=format&fit=crop&ixlib=rb-4.1.0', 'Cognitive Enhancement Technologies')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>AI/ML & Blockchain Education Platform</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Our pioneering AI/ML and Blockchain supported Techucation platform provides students with advanced learning technologies that augment cognitive abilities and enhance educational outcomes.
                  </p>
                  
                  <div className="info-section">
                    <h4>AI/ML Integration</h4>
                    <ul>
                      <li>Artificial Intelligence powered learning systems</li>
                      <li>Machine Learning adaptive curricula</li>
                      <li>Personalized learning path optimization</li>
                      <li>Intelligent tutoring and assessment</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Blockchain Technology</h4>
                    <ul>
                      <li>Secure credential verification systems</li>
                      <li>Decentralized learning record management</li>
                      <li>Smart contract-based achievement tracking</li>
                      <li>Blockchain-verified certification programs</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1515879218367-8466d910aaa4?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="AI ML Blockchain Education" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1515879218367-8466d910aaa4?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.1.0', 'AI ML Blockchain Education')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Advanced Information Systems</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    We develop complex information systems designed to support neurological limits that lead to forgetfulness and oversight, making lives and brains more efficient through technology integration.
                  </p>
                  
                  <div className="info-section">
                    <h4>Information Management</h4>
                    <ul>
                      <li>Complex information processing systems</li>
                      <li>Neurological limitation support technologies</li>
                      <li>Memory augmentation platforms</li>
                      <li>Cognitive efficiency optimization tools</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Brain-Computer Integration</h4>
                    <ul>
                      <li>Brain-computer interface development</li>
                      <li>Neural pathway enhancement systems</li>
                      <li>Cognitive load balancing technologies</li>
                      <li>Mental performance optimization platforms</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1591796436925-c4f0b6e6b6bc?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="Advanced Information Systems" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1591796436925-c4f0b6e6b6bc?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0', 'Advanced Information Systems')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="immigration-service-card">
            <div className="service-header">
              <h3>Why Choose Our Techucation Solutions?</h3>
            </div>
            <div className="service-content">
              <div className="service-text">
                <p style={{fontSize: '1.1rem', marginBottom: '30px'}}>
                  We pioneer efforts in making learning AI/ML and Blockchain supported Techucation, focusing on overcoming cognitive limitations and enhancing human learning capabilities.
                </p>
                
                <div className="info-section">
                  <h4>Cutting-Edge Technology</h4>
                  <p>Advanced AI/ML and Blockchain integration for revolutionary learning experiences.</p>
                </div>
                
                <div className="info-section">
                  <h4>Cognitive Enhancement</h4>
                  <p>Brain-computer interface technologies and cognitive augmentation systems.</p>
                </div>
                
                <div className="info-section">
                  <h4>Efficiency Innovation</h4>
                  <p>Complex information systems designed to make lives and brains more efficient.</p>
                </div>
                
                <div className="info-section">
                  <h4>Future-Ready Learning</h4>
                  <p>Overcoming neurological limits through advanced technological solutions.</p>
                </div>
                
                <div style={{marginTop: '32px', padding: '24px', background: 'rgba(0,0,0,0.05)', borderRadius: '12px'}}>
                  <p style={{margin: '0', fontSize: '1rem', lineHeight: '1.6', fontStyle: 'italic'}}>
                    "It is a matter of time when our neurological limits, that lead to forgetfulness and oversight, will be supported by complex information systems to make our lives and brains more efficient" - Google Founder Eric Schmidt
                  </p>
                </div>
              </div>
              <div className="service-image">
                <img 
                  src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.1.0" 
                  alt="Techucation Innovation Excellence" 
                  onClick={() => openLightbox('https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.1.0', 'Techucation Innovation Excellence')}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
          </div>
          
          <div className="immigration-page-cta-section">
            <h3>Transform Learning with Techucation</h3>
            <p>Ready to enhance cognitive abilities with AI/ML and Blockchain technology? Contact our education specialists.</p>
            <a href="/contact" className="btn immigration-btn-primary">Get Started</a>
          </div>
        </div>
      </section>
      
      <Lightbox 
        isOpen={lightboxOpen}
        imageSrc={lightboxImage.src}
        imageAlt={lightboxImage.alt}
        onClose={closeLightbox}
      />
    </PageLayout>
  );
};

export default Education;